import * as React from 'react';

export const IconAddPhotoPlus = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		fill="currentColor"
		version="1.1"
		viewBox="0 0 1200 1200"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m1170 645c0 13.809-11.195 25.004-25.004 25.004h-474.99v474.99c0 13.809-11.195 25.004-25.004 25.004h-89.996c-13.809 0-25.004-11.195-25.004-25.004l-0.003907-474.99h-474.99c-13.793-0.007812-24.988-11.195-24.988-25.004v-89.996c0-13.809 11.195-25.004 25.004-25.004h474.99v-475c0-13.809 11.195-25.004 25.004-25.004h89.996c13.809 0 25.004 11.195 25.004 25.004v474.99h474.99c13.809 0 25.004 11.195 25.004 25.004l-0.007813 89.996z"
			fill="currentColor"
		/>
	</svg>
);
